import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useT } from "@/i18n/I18nContext";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { MapPin, Home } from "lucide-react";

// Location cascade locked to Mali: Region/District > Commune (dropdown) + Ville/Quartier (free text)
export const CascadeSelect = ({ region, city, neighborhood, onRegion, onCity, onNeighborhood, large = true, testid = "cascade" }) => {
  const { t } = useT();
  const [regions, setRegions] = useState({});

  useEffect(() => {
    api.get("/mali-locations").then((r) => setRegions(r.data.regions || {})).catch(() => {});
  }, []);

  const cities = region && regions[region] ? regions[region] : [];
  const trigger = large ? "h-14 text-base" : "h-11";

  return (
    <div className="space-y-3">
      <div className="grid sm:grid-cols-2 gap-3">
        <div>
          <Label className="flex items-center gap-1.5 text-secondary font-semibold">
            <MapPin className="h-4 w-4" /> {t("auth.selectRegion")}
          </Label>
          <Select value={region || ""} onValueChange={(v) => { onRegion(v); onCity(""); }}>
            <SelectTrigger className={`mt-1.5 ${trigger}`} data-testid={`${testid}-region`}><SelectValue placeholder="Mali —" /></SelectTrigger>
            <SelectContent>
              {Object.keys(regions).map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-secondary font-semibold">{t("auth.selectCity")}</Label>
          <Select value={city || ""} onValueChange={onCity} disabled={!region}>
            <SelectTrigger className={`mt-1.5 ${trigger}`} data-testid={`${testid}-city`}><SelectValue placeholder="—" /></SelectTrigger>
            <SelectContent>
              {cities.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
      {onNeighborhood && (
        <div>
          <Label className="flex items-center gap-1.5 text-secondary font-semibold">
            <Home className="h-4 w-4" /> {t("auth.quartier")}
          </Label>
          <Input value={neighborhood || ""} onChange={(e) => onNeighborhood(e.target.value)}
            className={`mt-1.5 ${large ? "h-14 text-base" : "h-11"}`} placeholder="Ex : Badalabougou, rue 12…" data-testid={`${testid}-quartier`} />
          <p className="text-xs text-muted-foreground mt-1">{t("auth.quartierHint")}</p>
        </div>
      )}
    </div>
  );
};
